util = require("musecoreui/util/util.coffee")
storageUtil = require("musecoreui/util/storage_util.coffee")
objectUtil = require("musecoreui/util/object_util.coffee")
JobIndividualModel = require("musecoreui/models/individual/job_individual_model.coffee")
CompanyIndividualModel = require("musecoreui/models/individual/company_individual_model.coffee")
externalTracking = require("musecoreui/tracking/external_tracking.coffee")

# generates the url to track a virtual page for ga - need to generate the url
# in multiple submissions
#
# @param [String] action the action taken on the job for ga tracking (can be:
# apply, success, error)
trackVirtualPage = (action, model) ->
    # the virtual page url to submit to ga to track
    virtualPage = "/#{model.type()}-job/#{action}?company_name=#{model.company_short_name()}&job_name=#{model.short_name()}"
    util.trackPage(virtualPage)


loadCompanyTracking = (company_id, eventProps, cb) ->
    companyModel = new CompanyIndividualModel({
        id: company_id
    })

    companyModel.get({
        success: (response, model) ->
            eventProps = objectUtil.genObjectUnion([eventProps, model.getTrackProps()])
            cb(eventProps)
        # error will be called if we try to fetch a company that's been
        # archived. It has a valid company_id but is not fetchable via the api.
        # or if the requests fails...
        error: (response, model) ->
            cb(eventProps)
    })


loadJobTracking = (job_id, eventProps) ->
    jobModel = new JobIndividualModel({
        id: job_id
    })


    jobModel.get({
        success: (response, model) ->
            eventProps = objectUtil.genObjectUnion([eventProps, model.getTrackProps()])

            trackVirtualPage("success", model)
            util.track({
                oskarEvent: "Job Apply Success",
                oskarOpts: eventProps,
                gaCat: "ExternalJob",
                gaAction: "Successful"
            })
    })

trackNakedSuccess = (eventProps) ->
    eventProps.job_type = "external"
    eventProps.job_application_type = "naked"
    util.track({
        oskarEvent: "Job Apply Success",
        oskarOpts: eventProps,
        gaCat: "ExternalJob",
        gaAction: "Successful"
    })

# All the tracking logic for data retrieved from localstorage and cookies from
# the web host www.themuse.com
#
# @param [Number] company_id from metadata - 0 if no company specified
# @param [Obj] external_job_ids_list mapping of company id's to jobs applied - 0 if no job
# @param [string] external_job_id the id of the last job clicked
# @param [string] webHost the url for web - https://www.themuse.com
trackExternal = (has_visited, company_id, external_job_ids_list, external_job_id, webHost) ->
    eventProps = {
        script_company_id: company_id,
        script_job_id: external_job_id,
        script_version: if company_id then "company" else "default"
    }

    job_applies = external_job_ids_list?[company_id]

    # If we stored a job for the company_id then track the most recent one
    if job_applies?.length
        eventProps.attribution_confidence = "job_id matches company"
        eventProps.company_job_matches = "True"
        latest_job_id = job_applies.pop()
        loadJobTracking(latest_job_id, eventProps)

        # if the external job matches latest job, unset its cookie in externalTracking
        if latest_job_id == Number(external_job_id)
            externalTracking.setExternalJobId(null, metadata.cookie_domain)
        externalTracking.setExternalJobsList(external_job_ids_list, metadata.cookie_domain)

    # We have a company_id but can't find any matching job_id.
    # Track the company, then track NakedSuccess
    else if company_id
        eventProps.company_job_matches = "False"
        eventProps.attribution_confidence = "only matches company"
        loadCompanyTracking(company_id, eventProps, trackNakedSuccess)
    # We have no job for the company, nor a company_id then we can just
    # track the cookie external_job_id
    else if external_job_id
        eventProps.company_job_matches = "False"
        eventProps.attribution_confidence = "only matches latest job_id"
        loadJobTracking(external_job_id, eventProps)
        # Tell externalTracking to remove the external_job_id cookie
        externalTracking.setExternalJobId(null, metadata.cookie_domain)
    # else we have no company_id and no job_id but they have_visited before...
    # what can we do? just trackNakedSuccess..
    else if has_visited
        eventProps.attribution_confidence = "no matches"
        trackNakedSuccess(eventProps)

init = () ->
    {external_job_ids_list, external_job_id} = externalTracking.getStorage()

    trackExternal(metadata.has_visited, metadata.company_id, external_job_ids_list, external_job_id, metadata.cookie_domain)


init()

module.exports = trackExternal



// WEBPACK FOOTER //
// ./static/coffee/apps/frame/successful_apply_frame.coffee